export default __webpack_public_path__ + "static/media/bannerCDR01.19a95cf9.png";